module.exports = __webpack_public_path__ + "static/media/036.ffbbcec9.jpg";